import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Layout from "./components/Layout";
import { HelmetProvider } from "react-helmet-async";
import Helmet from "./components/Helmet";
import theme from "./theme";
import Steps from "./pages/Steps";
import { DocumentProvider } from "./contexts/document";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <CssBaseline />

        <Helmet
          title="freem | Bußgeldcheck"
          content="freem | Bußgeldcheck"
          keyword="freem | Bußgeldcheck"
        />

        <Router>
          <Layout>
            <Switch>
              <DocumentProvider>
                <Route path="/" component={Steps} />
              </DocumentProvider>

              <Route path="*">
                <Redirect to="/" />
              </Route>
            </Switch>
          </Layout>
        </Router>
      </HelmetProvider>
    </ThemeProvider>
  );
};

export default App;
